import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { type TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { useDarkMode } from '../../../DarkModeContext';

const StyledTooltipBase = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))<{ isDark?: boolean }>(({ theme, isDark }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: isDark ? '#2e2e2e' : '#f5f5f9',
        color: isDark ? '#e0e0e0' : 'rgba(0, 0, 0, 0.87)',
        maxWidth: 250,
        fontSize: theme.typography.pxToRem(12),
        border: isDark ? '1px solid #444' : '1px solid #dadde9',
    },
}));

const StyledTooltip = (props: TooltipProps) => {
    const { isDark } = useDarkMode();
    return <StyledTooltipBase {...props} isDark={isDark} />;
};

export default StyledTooltip;